<template>
  <BQdtCard
    name="analyticsHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'CustomsValueHelp',

  components: { BQdtCard },
}
</script>
